export const WAITING_REASONS = [
  { value: '', label: 'Без причины' },
  { value: 'client', label: 'Ждём ответа клиента' },
  { value: 'approval', label: 'Ждём согласования' },
  { value: 'equipment', label: 'Ждём оборудование' },
  { value: 'access', label: 'Ждём доступ на объект' },
  { value: 'other', label: 'Другое' },
];

const FIELD_LABELS = {
  title: 'название',
  description: 'комментарий',
  client_id: 'клиент',
  object_id: 'объект',
  project_id: 'проект',
  due_date: 'срок',
  priority: 'приоритет',
  status: 'статус',
  cost: 'сумма',
  category: 'категория',
  color: 'цвет',
  address: 'адрес',
  carry_items: 'что взять с собой',
  is_recurring: 'повторение',
  recurrence_type: 'период повторения',
  is_personal: 'тип задачи',
};

export const waitingReasonLabel = (value) => (
  WAITING_REASONS.find(item => item.value === value)?.label || 'Без причины'
);

export const formatWaitingDate = (value) => {
  if (!value) return '';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '' : date.toLocaleString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const historyEventLabel = (event) => {
  const labels = {
    created: 'Заявка создана',
    updated: 'Изменены поля заявки',
    status_changed: 'Статус изменён',
    waiting_started: 'Поставлена в ожидание',
    waiting_updated: 'Ожидание изменено',
    waiting_ended: 'Возвращена в работу',
    reminder_triggered: 'Напоминание сработало — возвращена в работу',
    completed: 'Задача завершена',
    paid: 'Оплата отмечена',
    reopened: 'Задача снова в работе',
    work_act_created: 'Создан акт выполненных работ',
    note: 'Добавлена заметка',
  };
  return labels[event?.event_type] || 'Изменение';
};

export const historyEventDetails = (event) => {
  const fields = event?.metadata?.changed_fields || Object.keys(event?.metadata?.changes || {});
  if (fields.length) return `Изменено: ${fields.map(field => FIELD_LABELS[field] || field).join(', ')}`;
  if (event?.event_type === 'paid' && event?.metadata?.amount != null) {
    return `Сумма: ${Number(event.metadata.amount).toLocaleString('ru-RU')} ₽`;
  }
  if (event?.event_type === 'work_act_created' && event?.metadata?.document_number) {
    return `Акт №${event.metadata.document_number}`;
  }
  return '';
};
